import { type AxiosError, type AxiosRequestConfig } from 'axios';

import apiClient from '@api-client';
import { useMutation } from '@tanstack/react-query';

type ApiClientMutationProps = {
  method: keyof typeof apiClient;
  requestOptions?: AxiosRequestConfig;
};

type ApiErrorData = {
  error: string;
  statusCode: number;
  message: string[];
};

type ApiError = {
  message: string[];
  data: ApiErrorData;
};

export const useApiClientMutation = <T = unknown, R = unknown>({
  method,
  requestOptions,
}: ApiClientMutationProps) =>
  useMutation<R, AxiosError<ApiError, never>, T, never>({
    mutationFn: (params) => {
      const fn = apiClient[method] as unknown as (
        params: T,
        requestOptions?: AxiosRequestConfig
      ) => Promise<R>;

      return fn(params, requestOptions);
    },
  });
